export enum SearchCriteriaType {
  SYMBOL = 'SYMBOL',
  NAME_AND_EXCHANGE = 'NAME_AND_EXCHANGE',
  ID = 'ID'
}
